
<template>
  <marquee-text
    v-if='noticias.length > 0'
    :duration="120"
    :repeat='2'>
    <p> {{noticias}} </p>
  </marquee-text>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'noticias',
  apollo: {
    posts: {
      query: gql`
      query MyQuery {
        posts: title_posts{
          title
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          this.noticias = ''
          data.posts.forEach((element) => {
            this.noticias += element.title + ' - '
          })
          console.log(this.noticias)
        }
      },
    },
  },
  data () {
    return {
      noticias: '',
    }
  },
  mounted () {
    setInterval(() => {
      if (Object.keys(this.$apollo.queries).includes('posts')) {
        this.$apollo.queries.posts.refetch()
      }
    }, 120 * 1000)
  },
}
</script>

<style scoped>
.marquee-text-text {
  color: #ffffff;
  padding-top: 15px;
  font-size: 38px;
  font-family: "Menlo", monospace;
}
</style>
